import React from "react";
import CategoriesRow from "../CategoriesRow/index";
import { Button } from "react-bootstrap";

export default (props) => {
  const { fetchCategories, categories, setCategories } = props;

  const updateCategoriesState = (category_id, name, description, priority) => {
    const newCategories = Object.assign([], categories);
    const updateIndex = newCategories.findIndex(
      (element) => element.category_id === category_id
    );
    newCategories[updateIndex].category_name = name;
    newCategories[updateIndex].category_description = description;
    newCategories[updateIndex].priority = priority;
    setCategories(newCategories);
  };

  const addNewCategory = () => {
    const newCategories = Object.assign([], categories);
    newCategories.push({
      category_id: null,
      category_name: null,
      category_description: null,
      image_src: null,
    });
    setCategories(newCategories);
  };

  const deteleEmptyCategory = () => {
    const newCategories = Object.assign([], categories);
    newCategories.pop();
    setCategories(newCategories);
  };

  return (
    <>
      <h2 className="pt-3 pl-3 pb-3">Categories</h2>
      {categories.map((element) => (
        <CategoriesRow
          category={element}
          updateCategoriesState={updateCategoriesState}
          deteleEmptyCategory={deteleEmptyCategory}
          fetchCategories={fetchCategories}
          categoriesLength={categories.length}
        />
      ))}
      <div className="d-flex justify-content-center">
        <Button onClick={addNewCategory}>Add Category</Button>
      </div>
    </>
  );
};
